import { Route, Switch, useRouteMatch } from 'react-router-dom';

import LoadComponentWithRetry from '@/app/routes/LoadComponentWithRetry';

const ViewComponent = LoadComponentWithRetry(() => import('./ViewUnitCostCatalogFactPage'));

const Routes = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={path} component={ViewComponent} />
    </Switch>
  );
};

export default Routes;
